import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInfoChat } from "./Store/Actions/chat-button.actions";
import TextoYTitulo from "@components/TextoYTitulo/TextoYTitulo";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";
import "./chatform.css";
import { isEmpty, isUndefined } from "lodash";
import useMediaQuery from "app/hooks/useMediaQuery";
import Btn_FullHD from "assets/img/iniciarChat/Btn_FullHD.png";
import Btn_iPad from "assets/img/iniciarChat/Btn_iPad.png";
import Btn_iPhone from "assets/img/iniciarChat/Btn_iPhone.png";
import { remAccents } from "@helpers/utils";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const CHAT_EN_LINEA_URL = "chat/formulario"; //process.env.REACT_APP_CHAT_LINEA_URL
const BORDER_TOP_COLOR = "#d7de00";

function ChatForm() {
  const dispatch = useDispatch();

  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");

  const [tituloInfo, setTituloInfo] = useState("");
  const [info, setInfo] = useState("");
  const [horario, setHorario] = useState("");
  const [status, setStatus] = useState(false);

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { textoInformativo } = useSelector(({ Base }) => Base.Chat);

  const defRoute = rutas?.filter((route) => route?.name === "Chat" && route?.identificadorSitio === "AC");

  useEffect(() => {
    dispatch(getInfoChat());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(textoInformativo)) {
      let texto = textoInformativo[0]?.texto?.html?.toString();
      let titulo = textoInformativo[0]?.titulo?.html?.toString();
      let horarioStr = textoInformativo[0]?.horario?.html?.toString();

      setTituloInfo(titulo);
      setInfo(texto);
      setHorario(horarioStr);
      checkStatusButton();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textoInformativo]);

  const checkStatusButton = () => {
    if (!isEmpty(textoInformativo)) {
      //obtenemos el nombre del día actual sin tildes y con inicial mayúscula.
      const dayBase = moment().locale("es").format("dddd");
      const dayStr = dayBase.toString();
      var dayStrName = dayStr.charAt(0).toUpperCase() + dayStr.slice(1);
      dayStrName = remAccents(dayStrName);

      //obtenemos la lista de nombres de campos del  Selector "textoInformativo".
      const daysKeys = Object.keys(textoInformativo[0]);

      //filtramos los nombres de campos para obtener los que contengan el nombre del día.
      const daySchedule = daysKeys.filter((item) => item.includes(dayStrName));
      //Filtramos los campos por nombre para obtener la hora de inicio y fin, que contengan el nombre del día.
      const filteredSchedule = Object.keys(textoInformativo[0])
        .filter((key) => daySchedule.includes(key))
        .reduce((obj, key) => {
          obj[key] = textoInformativo[0][key];
          return obj;
        }, {});

      //Obtenemos los valores de inicio y fin del rango de horario.
      const scheduleRange = Object.entries(filteredSchedule);
      const scheduleRangeFrom = scheduleRange[0];
      const scheduleRangeTo = scheduleRange[1];

      //Obtenemos por separado la hora y minuto actual.
      let curTime = moment().locale("es").format("LTS");

      //validamos que la hora esté en el rango.
      let result =
        moment(curTime, "HH:mm:ss").isAfter(
          moment(scheduleRangeFrom[1], "HH:mm:ss")
        ) &&
        moment(curTime, "HH:mm:ss").isBefore(
          moment(scheduleRangeTo[1], "HH:mm:ss")
        );

      setStatus(result);
    }
  };

  const renderButton = () => {
    if (status) {
      let btnImage =
        is4K || isFullHD || isMidLaptop
          ? Btn_FullHD
          : isIpadLandscape || isIpadPortrait
          ? Btn_iPad
          : Btn_iPhone;
      const res =
        "<a href=" +
        CHAT_EN_LINEA_URL +
        ' rel="noreferrer"><img src="' +
        btnImage +
        '" alt="Iniciar Chat"/></a>';
      return res;
    } else {
      <></>;
    }
  };

  const renderContent = () => {
    return !isUndefined(renderButton())
      ? info + horario + renderButton()
      : info + horario;
  };

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.title} />
      <TextoYTitulo
        title={tituloInfo}
        text={renderContent()}
        borderTopColor={BORDER_TOP_COLOR}
      />
    </>
  );
}

export default ChatForm;
